module.exports = __webpack_public_path__ + "img/securitydetailsLogo2.c3f7a07a.png";